(function(app, ng) {

    app.config([
        "figModalStateProvider", function(figModalStateProvider) {
            figModalStateProvider.state("Home.Dashboard.Support",
                {
                    url: "/Support",
                    component: "support",
                    resolve: {
                
                    }
                },
                { clickoutsidetoclose: false });
        }
    ]);

    app.component("support",
    {
        controller: supportController,
        templateUrl: "/App/Dashboard/Support/template.html",
        bindings: {
        
        }
    });


    supportController.$inject = [];
    function supportController() {
        var $ctrl = this;

        ng.extend($ctrl, 
        {
        
        });


    }

})(window.app, window.angular); //jshint ignore:line